import { useEffect, useState } from 'react'
import './App.scss'
import { Routes, Route, useLocation } from 'react-router-dom'
import Home from './Pages/Home/Home'
import CaseStudies from './Pages/CaseStudies/CaseStudies'
import OurWorks from './Pages/OurWorks/OurWorks'
import AboutUs from './Pages/AboutUs/AboutUs'
import Industries from './Pages/Industries/Industries'
import Works from './Pages/Works/Works'
import ContactUs from './Pages/ContactUs/ContactUs'
import OurClients from './Pages/OurClients/OurClients'
import PageNotFound from './Pages/404/404'
import OurStory from './Pages/AboutUs/Components/OurStory'
import OurJourney from './Pages/AboutUs/Components/OurJourney'
import LifeatKoolMind from './Pages/AboutUs/Components/LifeatKoolMind'
import Services from './Pages/Services/Services'
import WorkDetails from './Pages/WorkDetails/WorkDetails'
import ReactGA from 'react-ga';
import { applySeoTags, injectOrgJsonLd } from './utils/seo'
import resolveSeo from './utils/seoConfig'
import Career from './Pages/Career/Career'
import Blogs from './Pages/Blogs/Blogs'
import BlogDetails from './Pages/Blogs/BlogDetails'
import MobileApp from './Pages/Services/Pages/MobileApp'
import WebApp from './Pages/Services/Pages/WebApp'
import UiUx from './Pages/Services/Pages/UiUx'
import AIML from './Pages/Services/Pages/AIML'
import HealthCare from './Pages/Industries/Pages/HealthCare'
import Education from './Pages/Industries/Pages/Education'
import PetCare from './Pages/Industries/Pages/PetCare'
import Homecare from './Pages/Industries/Pages/Homecare'
import SocialMedia from './Pages/Industries/Pages/SocialMedia'
import Dating from './Pages/Industries/Pages/Dating'
import Fitness from './Pages/Industries/Pages/Fitness'
import TextileGarments from './Pages/Industries/Pages/TextileGarments'
import MCP from './Pages/Services/Pages/MCP'
import Pricing from './Pages/Pricing/Pricing'

ReactGA.initialize('G-WT6EEX895N');

function App() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    injectOrgJsonLd();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  useEffect(() => {
    const seo = resolveSeo(pathname)
    applySeoTags(seo)
  }, [pathname])

  return (
    <>
      <Routes>
        <Route  path="/" element={<Home />} />
        <Route  path="case-studies" element={<CaseStudies />} />
        <Route  path="case-studies/:route_title" element={<OurWorks />} />
        <Route  path="our-works" element={<Works />} />
        <Route  path="work-details/:link_title" element={<WorkDetails />} />
        <Route  path="services" element={<Services />} />
        <Route  path="services/mcp-development" element={<MCP />} />
        <Route  path="services/mobile-app-development" element={<MobileApp />} />
        <Route  path="services/web-app-development" element={<WebApp />} />
        <Route  path="services/ui-ux-designing" element={<UiUx />} />
        <Route  path="services/ai-machine-learning-development" element={<AIML />} />
        <Route  path="about" element={<AboutUs />} />
        <Route  path="blogs" element={<Blogs />} />
        <Route  path="blogs/:id" element={<BlogDetails />} />
        <Route  path="our-story" element={<OurStory />} />
        <Route  path="our-journey" element={<OurJourney />} />
        <Route  path="life-at-koolmind" element={<LifeatKoolMind />} />
        <Route  path="contact" element={<ContactUs />} />
        <Route  path="industries" element={<Industries />} />
        <Route  path="industries/healthcare" element={<HealthCare />} />
        <Route  path="industries/education" element={<Education />} />
        <Route  path="industries/petcare" element={<PetCare />} />
        <Route  path="industries/homecare" element={<Homecare />} />
        <Route  path="industries/social-media" element={<SocialMedia />} />
        <Route  path="industries/dating" element={<Dating />} />
        <Route  path="industries/fitness" element={<Fitness />} />
        <Route  path="industries/textile-garments" element={<TextileGarments />} />
        <Route  path="our-clients" element={<OurClients />} />
        <Route path="career" element={<Career/>} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  )
}

export default App
